"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsentService = void 0;
class ConsentService {
    constructor(consentConfiguration, client) {
        this.consentConfiguration = consentConfiguration;
        this.client = client;
    }
    getTermsAndConditionsTextPdfUrl(version) {
        return `${this.consentConfiguration.consentEndpoint}/consent/v1/texts/${this.consentConfiguration.appName}/${this.consentConfiguration.countryCode}/${this.consentConfiguration.language}/${this.consentConfiguration.termsAndConditionsTextId}/${version.majorVersion}.${version.minorVersion}/pdf`;
    }
    getPrivacyStatementTextPdfUrl() {
        return `${this.consentConfiguration.consentEndpoint}/consent/v1/texts/${this.consentConfiguration.appName}/${this.consentConfiguration.countryCode}/${this.consentConfiguration.language}/${this.consentConfiguration.privacyStatementTextId}/latest/pdf`;
    }
    async acceptTermsAndConditions(majorVersion, isWcar) {
        try {
            await this.client.storeConsentForMajorVersion(majorVersion, isWcar);
            return true;
        }
        catch (_a) {
            return false;
        }
    }
    async getLatestVersion(isWcar) {
        return this.client.getLatestVersion(isWcar);
    }
    async setVehicleSpecificConsentIfNeeded(vin, isWcar) {
        const consentResponse = await this.client.getVehicleSpecificConsent(vin, isWcar);
        if (!consentResponse.consentsGiven) {
            await this.client.storeVehicleSpecificConsent(vin, isWcar);
        }
    }
}
exports.ConsentService = ConsentService;
//# sourceMappingURL=ConsentService.js.map